import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/lib/auth';
import { lazyNamed } from '@/lib/lazy';

const ListsPage = lazyNamed(() => import('./pages'), 'ListsPage');
const CoursesPage = lazyNamed(() => import('./pages'), 'CoursesPage');
const ReviewsPage = lazyNamed(() => import('./pages'), 'ReviewsPage');

/**
 * Staff routes for features/collections. Paths are relative to /staff. Replace a placeholder by building the page in this folder
 * and pointing the lazy import at it; keep the permission wrapper.
 */
export const collectionsRoutes: RouteObject[] = [
  { path: 'lists', element: <RequirePermission permission={['lists']}><ListsPage /></RequirePermission> },
  { path: 'courses', element: <RequirePermission permission={['courses']}><CoursesPage /></RequirePermission> },
  { path: 'reviews', element: <RequirePermission permission={['editcatalogue']}><ReviewsPage /></RequirePermission> },
];
